import React, { useEffect, useState } from "react";
import styles from "./NewTemplate.module.css";
import style from "../EmailTemplate/EmailPage.module.css";
import WrappingContainer from "../../HOC/WrappingContainer/WrappingContainer";
import AttachmentIcon from "../../../assets/Imagess/attachmentIconEmail.svg";
import subjectICon from "../../../assets/Imagess/subjectIcon.svg";
import emailICon from "../../../assets/Imagess/emaildropdownicon.svg";
import Buttons from "../../Atoms/Buttons/Buttons";
import TextInput from "../../Atoms/Inputs/TextInput";
import * as Yup from "yup";
import CustomizedSelect from "../../Atoms/Inputs/CustomizedSelect";
import EmailContent from "../../Molecules/Email/EmailContent";
import { Formik, Form } from "formik";
import {
  useAddNotification,
  useFetchEmailTypes,
} from "../../../Hooks/Notification";
import { useLocation, useNavigate } from "react-router-dom";
import { useEmailContext } from "../../../Context/EmailContext";
import TextArea from "../../Atoms/Inputs/TextArea";
const NewTemplateEmail = () => {
  const addEmail = useAddNotification();
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedEmail, setNewSelectedEmail } = useEmailContext();

  const { data: emailTypesData } = useFetchEmailTypes();
  const initialValues = {
    notificationName: selectedEmail?.notificationName || "",
    notificationId:
      selectedEmail?.notificationId || "00000000-0000-0000-0000-000000000000",
    notificationType: selectedEmail?.notificationType || 0,
    notificationContent: selectedEmail?.notificationContent || "",
    subject: selectedEmail?.subject || "",
  };
  const validationSchema = Yup.object().shape({
    notificationName: Yup.string().required(),
    notificationId: Yup.string(),
    notificationType: Yup.number().required(),
    notificationContent: Yup.string(),
    subject: Yup.string().required(),
  });

  const selectApplicantOptions = emailTypesData?.data?.map(
    ({ notificationTypeId, notificationType }) => ({
      value: notificationTypeId,
      text: notificationType,
    })
  );
  useEffect(() => {
    setNewSelectedEmail({});
  }, [location]);
  return (
    <WrappingContainer>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          addEmail.mutate(values, {
            onSuccess: () => {
              navigate("/home/email");
              setNewSelectedEmail({});
            },
          });
        }}
      >
        {({
          values,
          errors,
          touched,
          setFieldValue,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => {
          return (
            <Form>
              <div className={style['email-container']}>
                <div className={style['icon-container']}>
                  <h2>Create New Email Template</h2>
                  <Buttons
                    text="حفظ"
                    rounded={true}
                    color="#F3223C"
                    type="Submit"
                    handleOnClick={handleSubmit}
                  />
                </div>
                <div className={styles['new-email-cont']}>
                  <TextInput
                    label="Name"
                    placeholder="Enter Email Name"
                    icon={emailICon}
                    name="notificationName"
                    value={values.notificationName}
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                    errors={errors.notificationName}
                    touched={touched.notificationName}
                  />
                  <CustomizedSelect
                    label="Email Type"
                    placeholder="Select Type"
                    options={selectApplicantOptions}
                    icon={emailICon}
                    name="notificationType"
                    value={values.notificationType}
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                    errors={errors.notificationType}
                    touched={touched.notificationType}
                  />
                  <TextInput
                    label="Subject"
                    placeholder="Enter Email Subject"
                    icon={subjectICon}
                    name="subject"
                    value={values.subject}
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                    errors={errors.subject}
                    touched={touched.subject}
                  />
                  {/* <TextInput
                    label='Attachment'
                    placeholder='Add Attachment'
                    icon={AttachmentIcon}
                  /> */}
                </div>
                {/* <EmailContent
                  name='notificationContent'
                  value={values.notificationContent}
                  onChange={(name, value) => {
                    setFieldValue(name, value);
                  }}
                  errors={errors.notificationContent}
                  touched={touched.notificationContent}
                /> */}
                <TextArea
                  label="Email Content "
                  rows="12"
                  cols="3"
                  name="notificationContent"
                  value={values.notificationContent}
                  onChange={(name, value) => {
                    setFieldValue(name, value);
                  }}
                  errors={errors.notificationContent}
                  touched={touched.notificationContent}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </WrappingContainer>
  );
};

export default NewTemplateEmail;
